import { render, staticRenderFns } from "./TablePage.vue?vue&type=template&id=f50a14b2&"
import script from "./TablePage.vue?vue&type=script&lang=js&"
export * from "./TablePage.vue?vue&type=script&lang=js&"
import style0 from "./TablePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports